import React, { useContext, useRef } from 'react';
import {
    Marker,
    Popup,
} from "react-leaflet";
import L from 'leaflet';
import { spotList } from '../register/config';
import { useCookies } from "react-cookie";
// eslint-disable-next-line
import { Context } from '../../../store/reducer';

const Component = ({latitude, longitude, draggable=false}) => {
    const { state, dispatch } = useContext(Context);
    // eslint-disable-next-line
    const [cookies,setCookie,removeCookie] = useCookies(["spots"]);
    const spots = cookies.spots || []
    const iconUrl = new L.Icon({
        iconUrl: spotList[spotList.findIndex(spot => spot.name == state.newSpot.category)].src,
        iconRetinaUrl: spotList[spotList.findIndex(spot => spot.name == state.newSpot.category)].src,
        iconSize: [35, 35],
        iconAnchor: [17, 23],
        popupAnchor: [0, -50]
    })
    const popupRef = useRef(null)
    
    return (
    
        <Marker 
            position={[latitude,longitude]} 
            icon={iconUrl} 
            draggable={draggable}
            eventHandlers={{
                dragend(e) {
                    const position = e.target.getLatLng();
                    dispatch({
                        type: 'SET_NEW_SPOT',
                        category: state.newSpot.category,
                        latitude: position.lat,
                        longitude: position.lng,
                        name: state.newSpot.name,
                        memo: state.newSpot.memo
                    })
                },
            }}
        >
            
            <Popup ref={popupRef} autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
                <dl className="dl-list is-modal-spot is-first">
                    <dt >スポット名</dt>
                    <dd>
                        <input type="text" className="f-w-lg"
                        value={state.newSpot.name || state.newSpot.category}
                        onChange={e => dispatch({
                            type: 'SET_NEW_SPOT',
                            category: state.newSpot.category,
                            latitude: state.newSpot.latitude,
                            longitude: state.newSpot.longitude,
                            name: e.target.value,
                            memo: state.newSpot.memo
                        })}
                        placeholder="例：空き家" />
                    </dd>
                </dl>
                <dl className="dl-list is-modal-spot">
                    <dt>メモ</dt>
                    <dd>
                        <textarea rows='2' className='f-w-lg' 
                        value={state.newSpot.memo}
                        onChange={e => dispatch({
                            type: 'SET_NEW_SPOT',
                            category: state.newSpot.category,
                            latitude: state.newSpot.latitude,
                            longitude: state.newSpot.longitude,
                            name: state.newSpot.name,
                            memo: e.target.value
                        })}
                        placeholder='例：倒壊の恐れ'></textarea>
                    </dd>
                </dl>
                { state.registerMode &&
                    <ul className="submit-side">
                        <li>
                            <button className='c-btn c-btn-solid c-btn-xs' type="button" 
                                onClick={() => {
                                    spots.push(state.newSpot);
                                    setCookie("spots",JSON.stringify(spots), {maxAge:60*60*24*7});
                                    dispatch({
                                        type: 'SET_NEW_SPOT',
                                        category: null,
                                        latitude: null,
                                        longitude: null,
                                        name: null,
                                        memo: null 
                                    })
                                    popupRef.current._close()
                                }}>登録する</button>
                        </li>
                        <li>
                            <button className='c-btn c-btn-line c-btn-xs' type="button" 
                                onClick={() => {
                                    dispatch({
                                        type: 'SET_NEW_SPOT',
                                        category: null,
                                        latitude: null,
                                        longitude: null,
                                        name: null,
                                        memo: null 
                                    })
                                }}>削除する</button>
                        </li>
                    </ul>
                }
            </Popup>
            
        </Marker>       
    );
    
}

export default Component;
